import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ToggleButton from "../../../../../components/Universal/ToggleButton.component";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { FieldArray, Formik } from "formik";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";

const Body = ({
  columns = [],
  historyData = [],
  isReceiptOpen,
  setIsReceiptOpen,
}) => {
  const [showHistory, setShowHistory] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [submittedValues, setSubmittedValues] = useState(null);
  const [activeToggle, setActiveToggle] = useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];

  const handleToggle = (id) => {
    setActiveToggle((prev) => (prev === id ? null : id)); // toggle off if same
  };

  const subtotal = React.useMemo(() => {
    return selectedItems.reduce((acc, item) => acc + item?.price, 0);
  }, [selectedItems]);

  const taxPercent = 10; // Example tax percentage

  const taxAmount = (subtotal * taxPercent) / 100;
  const netTotal = subtotal + taxAmount;

  if (showHistory)
    return (
      <section className="FoodAndDiningHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={[]} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All food items and equipment payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to food and dining
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={historyData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="FoodAndDiningBody">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Food And Dining"} />

      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && <CustomBill data={submittedValues} vendorInfo={[]} />}
      </ScrollableModal>

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
        className="FoodAndDining mt-2"
      >
        <div
          style={{ background: "white", padding: "2rem", borderRadius: "10px" }}
          className="FoodAndDining__left"
        >
          <h2
            style={{
              color: "var(--grayColor)",
              fontWeight: "normal",
              borderBottom: "1px solid #ccc",
              paddingBottom: "0.5rem",
            }}
          >
            Add daily food & dining{" "}
          </h2>
          <p
            style={{
              color: "var(--grayColor)",
              marginTop: "0.5rem",
            }}
          >
            Choose only one option at a time
          </p>
          <div
            style={{ display: "flex", gap: "2rem", marginTop: "0.5rem" }}
            className="select"
          >
            <span
              style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
            >
              <label htmlFor="food-items">Add daily food items</label>
              <ToggleButton
                isActive={activeToggle === "food"}
                onToggle={() => handleToggle("food")}
              />
            </span>
            <span
              style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
            >
              <p>Add kitchen equipments</p>
              <ToggleButton
                isActive={activeToggle === "equipment"}
                onToggle={() => handleToggle("equipment")}
              />
            </span>
          </div>
          {activeToggle && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBlock: "1rem",
                  fontSize: "0.9rem",
                  color: "var(--grayColor)",
                }}
              >
                <p>
                  {activeToggle === "food"
                    ? "Add daily food items"
                    : activeToggle === "equipment" && "Add Kitchen equipment"}
                </p>
                <p>
                  Today:{" "}
                  <span style={{ color: "black" }}>Sunday, 02 Oct, 2025</span>
                </p>
              </div>
              <Formik
                initialValues={{
                  items: [{ name: "", quantity: "", price: "" }],
                }}
                onSubmit={(values) => {
                  console.log("Submitted:", values);
                  setSelectedItems(values.items);
                }}
              >
                {({ values, handleSubmit, setFieldValue, touched, errors }) => (
                  <form onSubmit={handleSubmit}>
                    <p
                      style={{
                        marginBottom: "1rem",
                        color: "var(--grayColor)",
                      }}
                    >
                      Buying Items
                    </p>
                    <FieldArray name="items">
                      {({ push, remove }) => (
                        <>
                          {values.items.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                gap: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <FormInput
                                type="text"
                                label="item"
                                name={`items[${index}].name`}
                                placeholder="Enter item name"
                                touched={touched}
                                errors={errors}
                                setFieldValue={(e) =>
                                  setFieldValue(
                                    `items[${index}].name`,
                                    e.target.value
                                  )
                                }
                              />

                              <FormInput
                                type="number"
                                label="quantity"
                                name={`items[${index}].quantity`}
                                placeholder="Enter item quantity"
                                touched={touched}
                                errors={errors}
                                setFieldValue={(e) =>
                                  setFieldValue(
                                    `items[${index}].quantity`,
                                    e.target.value
                                  )
                                }
                              />

                              <FormInput
                                type="number"
                                label="price"
                                name={`items[${index}].price`}
                                placeholder="Enter total price"
                                touched={touched}
                                errors={errors}
                                setFieldValue={(e) =>
                                  setFieldValue(
                                    `items[${index}].price`,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          ))}

                          <button
                            type="button"
                            onClick={() =>
                              push({ name: "", quantity: "", price: "" })
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              background: "none",
                              border: "none",
                              color: "#000",
                              fontSize: "1.2rem",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: "green",
                                color: "white",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "20px",
                              }}
                            >
                              +
                            </span>
                            Add
                          </button>
                        </>
                      )}
                    </FieldArray>

                    <button
                      type="submit"
                      style={{
                        marginTop: "2rem",
                        backgroundColor: "#719a5a",
                        padding: "1rem",
                        color: "white",
                        border: "none",
                        width: "100%",
                        borderRadius: "6px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    >
                      View
                    </button>
                  </form>
                )}
              </Formik>
            </>
          )}
        </div>
        <div
          style={{
            background: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="FoodAndDining__right"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "1rem",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2 style={{ color: "var(--grayColor)", fontWeight: "normal" }}>
              Confirmation of payment
            </h2>
            <button
              onClick={() => setShowHistory(true)}
              style={{ height: "2.5rem" }}
              className="blueActionBtnLight"
            >
              All payments history{" "}
            </button>
          </div>
          {showSuccess ? (
            <div className="billSuccess">
              <h2
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "var(--deepGreen3)",
                  fontWeight: "500",
                }}
              >
                You have confirm payment successfully
              </h2>
              <p
                style={{
                  marginTop: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Receipt ID: 23456789012
              </p>
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  marginBlock: "1rem",
                  fontWeight: "500",
                  fontSize: "1.2rem",
                  color: "var(--blueColor1)",
                  cursor: "pointer",
                }}
                onClick={() => setIsReceiptOpen(true)}
              >
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                style={{ width: "100%" }}
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            selectedItems.length > 0 && (
              <>
                <div className="bill-table-container">
                  <table
                    className="bill-table"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      textAlign: "left",
                    }}
                  >
                    <thead>
                      <tr>
                        <th style={{ padding: "0.75rem", width: "40%" }}>
                          Items ({selectedItems.length})
                        </th>
                        <th style={{ padding: "0.75rem", width: "30%" }}>
                          Quantity
                        </th>
                        <th style={{ padding: "0.75rem", width: "30%" }}>
                          Price
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItems.map((item, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "0.75rem",
                              borderTop: "1px solid #ddd",
                            }}
                          >
                            {item?.name}
                          </td>
                          <td
                            style={{
                              padding: "0.75rem",
                              borderTop: "1px solid #ddd",
                            }}
                          >
                            {item?.quantity}
                          </td>
                          <td
                            style={{
                              padding: "0.75rem",
                              borderTop: "1px solid #ddd",
                            }}
                          >
                            <span className="totalAmount">
                              ₹{" "}
                              {new Intl.NumberFormat("en-IN").format(
                                item?.price
                              )}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="totalContainer">
                  <div className="subSection">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      className="subTotal"
                    >
                      <span>Sub Total:</span>
                      <span>₹ {subtotal}</span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      className="taxes"
                    >
                      <span>Other tax (GST, SGST, CGST) in %</span>
                      <span className="taxPercentage">{taxPercent}</span>
                      <span>₹ {taxAmount}</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className="netTotal"
                  >
                    <span>Total:</span>
                    <span>₹ {netTotal}</span>
                  </div>
                </div>
                <div className="formContaienr">
                  <Formik
                    initialValues={{
                      vendorName: "",
                      vendorContact: "",
                      paidAmount: "",
                      confirmedBy: "",
                      paymentMode: "",
                    }}
                    validationSchema={VendorPaymentValidation}
                    onSubmit={(values) => {
                      console.log("Form Submitted:", values);
                      setSubmittedValues(values);
                      setShowSuccess(true);
                    }}
                  >
                    {({
                      setFieldValue,
                      handleSubmit,
                      touched,
                      errors,
                      setTouched,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="vendorPaymentForm"
                      >
                        <div className="vendorPaymentFormInputs">
                          <FormInput
                            label="Vendor name"
                            type="text"
                            name="vendorName"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor name"
                            setFieldValue={(e) =>
                              setFieldValue("vendorName", e.target.value)
                            }
                          />

                          <FormInput
                            label="Vendor contact"
                            type="text"
                            name="vendorContact"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor contact number"
                            setFieldValue={(e) =>
                              setFieldValue("vendorContact", e.target.value)
                            }
                          />

                          <FormInput
                            label="Paid amount (INR)"
                            type="number"
                            name="paidAmount"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter paid amount"
                            setFieldValue={(e) =>
                              setFieldValue("paidAmount", e.target.value)
                            }
                          />

                          <DropDownInput
                            name="confirmedBy"
                            label="Confirmed by"
                            placeholder="Choose confirmed by"
                            suggestionList={confirmedByOptions}
                            setFieldValue={(val) =>
                              setFieldValue("confirmedBy", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />

                          <DropDownInput
                            name="paymentMode"
                            label="Payment mode"
                            placeholder="Choose payment mode"
                            suggestionList={paymentModes}
                            setFieldValue={(val) =>
                              setFieldValue("paymentMode", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />
                        </div>

                        <button
                          // onClick={() => setIsReceiptOpen(true)}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            textAlign: "center",
                            marginTop: "1rem",
                          }}
                          type="submit"
                          className="confirmPaymentBtn actionBtn"
                        >
                          Confirm payment
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
